<template>
  <div class="shopList">
    <div :class="now_mid==item.mid?'item active':'item'" v-for="(item,index) in list" :key="index" @click="now_mid!=item.mid?changeShop(item):''">
      <div class="shop_name">
        <span>店铺名称：</span><span>{{item.shop_name}}</span>
      </div>
      <!-- <div>
        <span>店铺状态：</span><span>{{item.shop_status}}</span>
      </div> -->
      <div>
        <span>我的角色：</span><span>{{item.role_type==1?'老板（超级管理员）':'员工'}}</span>
      </div>
      <div>
        <span>加入时间：</span><span>{{item.created_at | toTime}}</span>
      </div>
      <div class="check" v-if="now_mid==item.mid">
        <van-checkbox :value="true" shape="square" checked-color="#31B157"></van-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { myShopList ,myShopChange} from "@/api/layout/user";
import { timestampToTime } from "@/utils/timestamp"
import Cookies from "@/utils/Cookies";
export default {
  name: "shopList",
  filters:{
    toTime(t){
      return timestampToTime(t)
    }
  },
  data() {
    return {
      list:[],
      now_mid:'',
    };
  },
  created() {
    this.getList()
  },
  mounted() {},
  methods: { 
    getList(){
      myShopList().then(res=>{
        this.now_mid = res.data.now_mid
        var list = []
        for (let i = 0; i < res.data.list.length; i++) {
          const item = res.data.list[i];
          if(item.mid != this.now_mid){
            list.push(item)
          }else{
            list.unshift(item)
          }
        }
        this.list = list
      })
    },
    // 切换店铺
    changeShop(item){
      this.$dialog.confirm({
        title: '提示',
        message: '确认切换到该店铺吗？',
      })
      .then(() => {
        myShopChange({mid:item.mid}).then(res=>{
          console.log('res',res)
          if(res.code == 200){
            // this.$store.dispatch("getAuth")
            this.$toast.success(res.message)
            Cookies.remove("order_data");
            Cookies.remove("order_total_num");
            Cookies.remove("order_active_index");
            var user = JSON.parse(Cookies.get("userInfo"))
            user.default_role_type = item.role_type
            Cookies.set("userInfo",JSON.stringify(user))
            Cookies.set("rule", JSON.stringify(res.data.rule));
            this.$router.go(-1)  
          }
        })
      })
      .catch(() => {
        // on cancel
      });
    }
   }
};
</script>

<style lang="less" scoped>
.shopList {
  .item{
    position: relative;
    margin:  0.3rem 0.3rem 0;
    background-color: #fff;
    border-radius: 0.1rem;
    padding: 0.2rem 0.3rem;
    line-height: 0.44rem;
    color: #999;
    box-sizing: border-box;
    overflow: hidden;
    &.active{
      border: 0.02rem solid #31B157;
    }
    .check{
      position: absolute;
      right: 0;
      top: 0;
    }
    .shop_name{
      &>span:nth-child(2){
        font-size: 0.32rem;
        font-weight: bold;
        color: #333;
      }
    }
    .btn{
      position: absolute;
      right: 0.3rem;
      bottom: 0.3rem;
    }
  }
}
</style>